// extracted by mini-css-extract-plugin
export default {"text":"CancelAutoRenewFamilyModal__text--1Wpy7"};